module.exports = __webpack_public_path__ + "img/arrow-left.f9a44e1c.svg";